export default __webpack_public_path__ + "static/media/2FVISUAL_Tour.f5897684.png";